import * as styles from './index.css';
export var getSectionHintLayout = function getSectionHintLayout(data) {
  var name = data.name,
    deadLine = data.deadLine,
    pricingInfo = data.pricingInfo;
  return "\n    <div class=\"".concat(styles['container'], "\">\n      <div class=\"").concat(styles['name'], "\">").concat(name, "</div>\n      <div class=\"").concat(styles['status'], "\">").concat(deadLine, "</div>\n      <div class=\"").concat(styles['pricing'], "\">").concat(pricingInfo, "</div>\n    </div>\n  ");
};